import React, { useState } from "react";
import Drawer from "../shared/Drawer";
import { STEP_TYPES, STEP_META } from "./sequenceUtils";

const CONDITIONS = [
  {
    type: STEP_TYPES.CONDITION,
    label: "If connected",
    description: "Check if lead accepted connection",
  },
];

const ACTIONS = [
  STEP_TYPES.CONNECTION_REQUEST,
  STEP_TYPES.MESSAGE,
  STEP_TYPES.VOICE_NOTE,
  STEP_TYPES.IN_MAIL,
  STEP_TYPES.PROFILE_VIEW,
  STEP_TYPES.FOLLOW,
  STEP_TYPES.LIKE_POST,
].map((type) => ({ type, ...STEP_META[type] }));

export default function StepPickerDrawer({ open, onClose, onSelect, isFirstStep = false }) {
  const [tab, setTab] = useState("actions");

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={isFirstStep ? "Build your sequence manually" : "Add a step"}
      widthClass="max-w-lg"
    >
      <p className="text-sm text-gray-500 mb-4">
        {isFirstStep
          ? "Choose the first step for your sequence."
          : "Choose the step to add at this point of the path."}
      </p>
      <div className="flex gap-2 mb-4">
        <button
          type="button"
          onClick={() => setTab("conditions")}
          className={`px-3 py-1.5 rounded-lg text-sm border ${
            tab === "conditions" ? "bg-gray-100 border-gray-300" : "border-transparent"
          }`}
        >
          Conditions
        </button>
        <button
          type="button"
          onClick={() => setTab("actions")}
          className={`px-3 py-1.5 rounded-lg text-sm border ${
            tab === "actions" ? "bg-gray-100 border-gray-300" : "border-transparent"
          }`}
        >
          LinkedIn actions
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {(tab === "conditions" ? CONDITIONS : ACTIONS).map((item) => (
          <button
            key={item.type + item.label}
            type="button"
            onClick={() => onSelect?.(item)}
            className="text-left border border-gray-200 rounded-xl p-3 hover:border-blue-400 hover:bg-blue-50/40 transition-colors"
          >
            <div className="text-sm font-semibold text-gray-900">{item.label}</div>
            <div className="text-xs text-gray-500 mt-1">{item.description}</div>
          </button>
        ))}
      </div>
      <div className="mt-6">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 rounded-lg border border-gray-200 text-sm"
        >
          Dismiss
        </button>
      </div>
    </Drawer>
  );
}
